// src/SeoManager.js
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { SEO_ROUTE_MAP } from "./seoRouteMap";

const baseUrl = `${window.location.protocol}//${window.location.hostname}`;
const API_URL = baseUrl.replace(/\/?$/, "/") + "api/fos/seo-items";



function setMeta(name, content) {
  if (!content) return;

  let tag = document.querySelector(`meta[name="${name}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute("name", name);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

function setLang(lang) {
  if (!lang) return;
  document.documentElement.setAttribute("lang", lang);
}

export default function SeoManager() {
  const location = useLocation();
  const [routeSeoMap, setRouteSeoMap] = useState(null);

  // 1️⃣ Load SEO list once on app load
  useEffect(() => {
    const fetchSeo = async () => {
      try {
        const res = await fetch(API_URL);
        const json = await res.json();

        if (json.status !== "success" || !Array.isArray(json.data)) {
          console.error("Unexpected SEO response:", json);
          return;
        }

        const items = json.data;

        // Build map: routePath -> seoItem
        const map = {};

        Object.entries(SEO_ROUTE_MAP).forEach(([routePath, pageName]) => {
          const match = items.find((item) => item.page_name === pageName);
          if (match) {
            map[routePath] = match;
          }
        });

        setRouteSeoMap(map);
      } catch (err) {
        console.error("Failed to fetch SEO data:", err);
      }
    };

    fetchSeo();
  }, []);

  // 2️⃣ On every route change, apply SEO for that route
  useEffect(() => {
    if (!routeSeoMap) return;

    const path = location.pathname; // e.g. "/contact-us"
    const seo = routeSeoMap[path];

    if (!seo) {
      // Optional: log or set some default SEO here
      // console.log("No SEO config for route:", path);
      return;
    }

    // <title>
    if (seo.title) {
      document.title = seo.title;
    }

    // <meta name="description">
    setMeta("description", seo.meta_description);

    // <meta name="keywords">
    setMeta("keywords", seo.meta_keywords);

    // <html lang="...">
    setLang(seo.meta_language || "en");
  }, [location, routeSeoMap]);

  return null; // This component doesn't render any UI
}
